import React from 'react';
import { PropTypes } from 'prop-types';
import { Icon } from '@ontruck/orc';

const Header = ({ className, customClassName, onClose, t }) => (
  <div className={`${className} ${customClassName}`}>
    <div className="info">
      <h2>{t('cancel.title')}</h2>
    </div>
    <button type="button" className="close" onClick={onClose}>
      <Icon glyph="close" color="grey500" size="16px" />
    </button>
  </div>
);

Header.propTypes = {
  className: PropTypes.string,
  customClassName: PropTypes.string,
  onClose: PropTypes.func,

  t: PropTypes.func,
};

Header.defaultProps = {
  className: '',
  customClassName: '',
  onClose: () => ({}),
  t: (t) => t,
};

export default Header;
